/**
  * 商城订单 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const goodztorder = {
    // 列表
    list (params) {
        return axios.get(api + 'ztorders/list',{params:params})
    },
    //发货
    ship (params) {
        return axios.post(api + 'ztorders/ship',qs.stringify(params))
    },
}


// 导出接口
export default goodztorder